import { render, staticRenderFns } from "./occupation-lits.vue?vue&type=template&id=194dccd1&scoped=true"
import script from "./occupation-lits.vue?vue&type=script&lang=js"
export * from "./occupation-lits.vue?vue&type=script&lang=js"
import style0 from "./occupation-lits.vue?vue&type=style&index=0&id=194dccd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194dccd1",
  null
  
)

export default component.exports